import { jsx as _jsx } from "react/jsx-runtime";
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js'; // needed because of styled-components 4 and IE11 atm? Look to remove when can as this is huge.
import '@digitools/honest-react/dist/global.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/App';
import * as serviceWorker from './serviceWorker';
import { getEnvVariable, isDev } from './utils/envUtils';
import Sawmill from './utils/Sawmill';
Sawmill.configure({
  dev: isDev()
});
// @ts-ignore
if (newrelic && !isDev()) {
  // @ts-ignore
  newrelic.addRelease('dpp-ui', process.env.REACT_APP_VERSION);
}
//@ts-ignore
window.recaptchaOptions = {
  enterprise: !!getEnvVariable('googleRecaptchaEnterprise')
};
ReactDOM.render(_jsx(React.StrictMode, {
  children: _jsx(App, {})
}), document.getElementById('root'));
serviceWorker.unregister();